import React, { useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
// material-ui
import { styled, useTheme } from "@mui/material/styles";
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
// project imports
import Breadcrumbs from "ui-component/extended/Breadcrumbs";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Customization from "../Customization";
import navigation from "menu-items";
import useConfig from "hooks/useConfig";
import { drawerWidth } from "store/constant";
import { openDrawer } from "store/slices/menu";
import { useDispatch, useSelector } from "store";
import "../../views/Dashboard/Dashboard.css";
// assets
import { IconChevronRight } from "@tabler/icons";
import { connect } from "react-redux";

// styles
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
      padding:"0px !important",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter,
      }),
      [theme.breakpoints.up("md")]: {
        marginLeft: -(drawerWidth - 0),
        width: `calc(100% - ${drawerWidth}px)`,
      },
      [theme.breakpoints.down("md")]: {
        marginLeft: "0px",
        width: `calc(100% - ${drawerWidth}px)`,
        padding: "16px",
      },
      [theme.breakpoints.down("sm")]: {
        marginLeft: "10px",
        width: `calc(100% - ${drawerWidth}px)`,
        padding: "16px",
        marginRight: "10px",
      },
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.shorter,
      }),
      marginLeft: 0,
      padding:"0px !important",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      width: `calc(100% - ${drawerWidth}px)`,
      [theme.breakpoints.down("md")]: {
        marginLeft: "20px",
      },
      [theme.breakpoints.down("sm")]: {
        marginLeft: "10px",
      },
    }),
  })
);

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = (props) => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const { ownerLabelsName } = props.label;
  const matchDownMd = useMediaQuery(theme.breakpoints.down("lg"));

  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);
  const { container } = useConfig();
  const [isActive, setIsActive] = useState(0);

  React.useEffect(() => {
    if (pathname === "/dashboard") {
      setIsActive(1);
    } else {
      setIsActive(0);
    }
    if (pathname === "/properties") {
      setIsActive(2);
    } else {
      setIsActive(0);
    }
    if (pathname === "/tenant-list") {
      setIsActive(3);
    } else {
      setIsActive(0);
    }
  }, [pathname]);

  React.useEffect(() => {
    dispatch(openDrawer(!matchDownMd));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownMd]);

  const header = useMemo(
    () => (
      <Toolbar>
        <Header />
      </Toolbar>
    ),
    []
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {/* header */}
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: "#807667",
          color: "#F5D792",
          transition: drawerOpen ? theme.transitions.create("width") : "none",
        }}
      >
        {header}
      </AppBar>

      {/* drawer */}
      <Sidebar />

      {/* main content */}
      <Main
        theme={theme}
        open={drawerOpen}
        sx={{
          bgcolor: "#DCD6D0",
          marginX: 0,
          mt: 10.3,

          padding: 0,
          borderRadius: 0,
        }}
      >
        <>
          <div className="mb-2"></div>
          {/* <div className="fr-chat-main-a mb-2">
            <div className="frs-chat-desc">
              <>
                <Link
                  to="/dashboard"
                  style={{ textDecoration: "none" }}
                  className={isActive == 1 ? "top-links-active" : "top-links"}
                >
                  <h5 className="main-link">
                    {ownerLabelsName
                      ? ownerLabelsName.filter((e) => e.key == "lbl_dashboard")
                        .length > 0
                        ? ownerLabelsName.filter((e) => e.key == "lbl_dashboard")[0][
                        "value"
                        ] || "lbl_dashboard"
                        : "lbl_dashboard"
                      : "lbl_dashboard"}
                  
                  </h5>
                </Link>
                <h5
                  style={{
                    color: "#fff",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                >
                  {" "}
                  |
                </h5>
                <Link
                  to="/properties"
                  style={{ textDecoration: "none" }}
                  className={isActive == 2 ? "top-links-active" : "top-links"}
                >
                  <h5 className="main-link">
                    {ownerLabelsName
                      ? ownerLabelsName.filter((e) => e.key == "lbl_properties")
                        .length > 0
                        ? ownerLabelsName.filter((e) => e.key == "lbl_properties")[0][
                        "value"
                        ] || "lbl_properties"
                        : "lbl_properties"
                      : "lbl_properties"}
              
                  </h5>
                </Link>
                <h5
                  style={{
                    color: "#fff",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                >
                  {" "}
                  |
                </h5>
                <Link
                  to="/tenant-list"
                  style={{ textDecoration: "none" }}
                  className={isActive == 3 ? "top-links-active" : "top-links"}
                >
                  <h5 className="main-link">
                    {ownerLabelsName
                      ? ownerLabelsName.filter((e) => e.key == "lbl_tenant_list")
                        .length > 0
                        ? ownerLabelsName.filter(
                          (e) => e.key == "lbl_tenant_list"
                        )[0]["value"] || "lbl_tenant_list"
                        : "lbl_tenant_list"
                      : "lbl_tenant_list"}
                 
                  </h5>
                </Link>
              </>
            </div>
          </div> */}
          {/* breadcrumb */}
          {container && (
            <Container maxWidth="lg">
              <Breadcrumbs
                separator={IconChevronRight}
                navigation={navigation}
                icon
                title
                rightAlign
              />
              <Outlet />
            </Container>
          )}
          {!container && (
            <>
              <Breadcrumbs
                separator={IconChevronRight}
                navigation={navigation}
                icon
                title
                rightAlign
              />
              <Outlet />
            </>
          )}
        </>
      </Main>
      <Customization />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, {})(MainLayout);
// export default MainLayout;
